import { render, staticRenderFns } from "./CarrierDetails.vue?vue&type=template&id=ac64ba86&scoped=true&"
import script from "./CarrierDetails.vue?vue&type=script&lang=js&"
export * from "./CarrierDetails.vue?vue&type=script&lang=js&"
import style0 from "./CarrierDetails.vue?vue&type=style&index=0&id=ac64ba86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac64ba86",
  null
  
)

export default component.exports